module.exports = __webpack_public_path__ + "assets/images/sizeofboat-03.44bc935172a5bc80d3a1eeec1e6875f0.svg";